
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown, DropdownButton, DropdownDivider, DropdownItem, DropdownMenu } from '../../catalyst/dropdown';
import { ErrorMessage, Field } from '../../catalyst/fieldset';
import config from '../../config';

import { getIconForTransfer } from './../../utils';

export default function AddNewAccount() {
    const navigate = useNavigate();

    const [musicKit, setMusicKit] = useState(null);

    const [isAppleMusicAuthorzing, setIsAppleMusicAuthorzing] = useState(false);

    //Load apple music Lib
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js-cdn.music.apple.com/musickit/v1/musickit.js';
        script.async = true;
        script.onload = () => {
            setMusicKit(window.MusicKit.configure({
                developerToken: config.appleDeveloperToken,
                app: {
                    name: 'Music Porter',
                    build: '1.0.0'
                }
            }));
        };
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);


    const handleAppleConnect = (event) => {
        try {
            if (musicKit) {
                setIsAppleMusicAuthorzing(true);
                // Example: Play a song from the Apple Music catalog
                musicKit.authorize().then((token) => {
                    setIsAppleMusicAuthorzing(false);
                    const apiUrl = `${config.apiUrl}/appleMusic/auth/callback/internal?token=${encodeURIComponent(token)}`;

                    const user = JSON.parse(localStorage.getItem('user'));
                    fetch(apiUrl, {
                        headers: {
                            'Authorization': 'Bearer ' + user.accessToken,
                        }
                    })
                        .then(response => {
                            if (!response.ok) {
                                navigate(config.accountsPath + '?message=APPLE_ADD_ERROR')
                            }
                            return response.json();
                        })
                        .then(data => {
                            window.location.href = (config.accountsPath + '?message=APPLE_ADDED&addedAccount=' + data.id)

                        })
                        .catch(error => {
                        });

                });
            } else {
                console.log("failed to connect music kit")
            }
        } catch (error) {
            console.error('Error connecting Apple music:', error);
        } finally {

        }
    };



    const menuItems = [
        { label: 'Spotify', onClick: () => {setIsAppleMusicAuthorzing(false); navigate("/connect/spotify")}, icon: getIconForTransfer("spotify") },
        { label: 'Apple Music', onClick: handleAppleConnect, icon: getIconForTransfer("appleMusic") },
        { label: 'Tidal', onClick: () => {setIsAppleMusicAuthorzing(false); navigate("/connect/tidal")}, icon: getIconForTransfer("tidal") },
        { label: 'YouTube', onClick: () => {setIsAppleMusicAuthorzing(false); navigate("/connect/youtube")}, icon: getIconForTransfer("youtube") },
        { label: 'YouTube Music', onClick: () => {setIsAppleMusicAuthorzing(false); navigate("/connect/youtubeMusic")}, icon: getIconForTransfer("youtube", true) },
        // Add more items as needed
    ];


    return (
        <>
        <div>
            <div className='flex flex-col'>
                <div className='flex justify-end'>
                    <Dropdown>
                        <DropdownButton className="cursor-pointer" outline>
                            Add New Account
                            <ChevronDownIcon />
                        </DropdownButton>
                        <DropdownMenu>

                            {menuItems.map((item, index) => (
                                <>
                                    <DropdownItem key={index} onClick={item.onClick} className="cursor-pointer">{item.icon}&nbsp;{item.label}</DropdownItem>
                                    <DropdownDivider />
                                </>

                            ))}
                        </DropdownMenu>
                    </Dropdown>
                </div>

                {/* Message appears below the dropdown */}
                {isAppleMusicAuthorzing && (
                    <div className="mt-2">
                        <Field>
                            <ErrorMessage>Authorize Apple Music opened in popup window/tab</ErrorMessage>
                        </Field>
                    </div>
                )}
            </div>
        </div>
        </>
    );
}